import React from "react";
import Icon from "../components/Icon";
import Form from "../components/Form";
import ReactGA from "react-ga";
import { checkIBAN } from "../actions/Users";
import { connect } from "react-redux";
import { message } from "../actions";
import { translations } from "../config";

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		checkIBAN: ( a_formData ) =>
		{
			return dispatch( checkIBAN( a_formData ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class PaymentFields extends React.Component
{
	constructor( props )
	{
		super( props );
		
		// Zustimmungsfeld beim Neuladen deaktivieren
		this.props.fieldValues.payment &&
		Object.keys( this.props.fieldValues.payment ).filter( a_key => a_key === "sepa_approval" ).forEach( a_key => delete this.props.fieldValues.payment[a_key] );
	}
	
	componentDidMount()
	{
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
	} // function componentDidMount()
	
	handleStep( event, formData, a_next = true )
	{
		event.preventDefault();
		this.props.saveValues( formData, "payment" );
		
		if ( a_next )
		{
			// Prüfung auf richtigkeit der IBAN
			this.props.checkIBAN( formData ).then(
				result =>
				{
					if ( result )
					{
						this.props.nextStep();
					}
				}
			);
		}
		else
		{
			this.props.previousStep();
		}
		
	} // function handleStep()
	
	render()
	{
		return <div className={"col s12"}>
			<h3>Zahlung</h3>
			<p>Ermächtigung zum Einzug von Forderungen durch SEPA-Lastschriftmandat</p>
			<Form id={`form-new-user-service`}
			      submitValue={[ <Icon key={`form-new-user-icon`} iconName={"next"}/>, <span key={`form-new-user-text`}>nächster Schritt</span> ]}
			      cancelValue={[ <Icon key={`form-new-user-cancel-icon`} iconName={"leave"}/>, <span key={`form-new-user-cancel-text`}>Zurück zum Warenkorb</span> ]}
			      onSubmit={( event, formData ) => this.handleStep( event, formData )}
			      onCancel={( event, formData ) => this.handleStep( event, formData, false )}
			      fields={[
				      {
					      name: "account_owner",
					      title: "Kontoinhaber",
					      type: "text",
					      maxLength: "80",
					      required: true,
					      className: "col s12 m6 l4"
				      },
				      {
					      name: "iban",
					      title: "IBAN",
					      type: "text",
					      maxLength: "50",
					      required: true,
					      className: "col s12 m6 l4"
				      },
				      {
					      name: "credit_institution",
					      title: "BIC",
					      type: "text",
					      maxLength: "50",
					      required: true,
					      className: "col s12 m6 l4"
				      },
				      {
					      name: "sepa_approval",
					      title: "Lastschrifteinzug akzeptieren",
					      options: <span>Ich ermächtige Zahlungen von meinem Konto mittels Lastschrift einzuziehen.<br/>
						      Zugleich weise ich mein Kreditinstitut an, die von {translations.de_DE.words.appName} auf mein Konto gezogenen Lastschriften einzulösen.</span>,
					      type: "checkbox",
					      className: "col s12",
					      required: true
				      }
			      ]}
			      errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
			      values={this.props.fieldValues.payment}
			      additionalFormHtml={
				      <div className={"relative"}>
					      <div className={"col s12 primary-color white-text seperator"}>
						      <h6>Hinweis</h6>
					      </div>
					      <div className={"col s12 unset-padding dashed-block hasTitle"}>
						      <div className={"col s12"}>
							      <p>Vor dem Einzug einer SEPA-Basis-Lastschrift werden wir Sie über den Einzug in dieser Verfahrensart unterrichten.</p>
							      <p>Sie können jederzeit innerhalb von acht Wochen, beginnend mit dem Belastungsdatum,
								      die Einzungsermächtigung schriftlich widerrufen und die Erstattung
								      des belasteten Betrags verlangen.
								      <br/>Es gelten dabei die mit Ihrem Kreditinstitut vereinbarten Bedingungen.</p>
							      <p>Im Falle einer Nichteinlösung einer Lastschrift ist {translations.de_DE.words.appName} berechtigt, ohne weitere Information oder Ankündigung den Zugang des
								      Teilnehmers
								      zum imera.esch.design zu sperren und/oder den Vertrag fristlos zu kündigen. Für die von Ihnen verschuldeten Rückbuchungen der Bankeinzüge
								      oder
								      Kreditkartenabbuchungen berechnen wir Ihnen eine Gebühr von EUR 8,00. Ihnen bleibt der Nachweis eines geringeren oder gar keines Schadens
								      vorbehalten. Ausgenommen hiervon ist der begründete Widerspruch gegen eine Lastschrift.</p>
						      </div>
					      </div>
					      <div className={"col s12 seperator"}/>
				      </div>
			      }
			/>
		</div>;
		
	} // function render()
	
} // class

PaymentFields = connect(
	null,
	mapDispatchToProps
)( PaymentFields );

export default PaymentFields;
